var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDollarCircle = function SvgDollarCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#123862"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99 5.472c-.5 0-.952.433-.952 1.024 0 .402.086.586.163.684.082.104.22.197.492.294l3.225 1.12c.36.128.75.319 1.037.686.293.374.419.85.419 1.424 0 1.201-.94 2.224-2.152 2.224H8.214c-1.343 0-2.376-1.129-2.376-2.464a.6.6 0 1 1 1.2 0c0 .728.55 1.264 1.176 1.264h2.008c.5 0 .952-.434.952-1.024 0-.402-.087-.586-.163-.684-.082-.104-.22-.197-.492-.294l-3.226-1.12c-.359-.128-.749-.319-1.036-.686-.294-.374-.42-.85-.42-1.424 0-1.202.94-2.224 2.153-2.224h2.008c1.342 0 2.376 1.128 2.376 2.464a.6.6 0 1 1-1.2 0c0-.728-.55-1.264-1.176-1.264H7.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1 3.2a.6.6 0 0 1 .6.6v9.6a.6.6 0 0 1-1.2 0V3.8a.6.6 0 0 1 .6-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1 1.2a7.4 7.4 0 1 0 0 14.8 7.4 7.4 0 0 0 0-14.8ZM.5 8.6a8.6 8.6 0 1 1 17.2 0 8.6 8.6 0 0 1-17.2 0Z"
  }))));
};
export default SvgDollarCircle;